import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import * as styles from './CompanyTooltip.scss';

export default class Tooltip extends Component {
  componentDidMount() {
    if (!this.container) {
      this.container = document.createElement('div');
      this.container.classList.add(styles.tooltip);
      this.container.classList.toggle('rtl', this.props.isRtl);
      document.body.appendChild(this.container);
    }
    this.componentDidUpdate();
  }

  componentDidUpdate() {
    if (!this.props.tooltipFor) return null;
    const bounds = this.props.tooltipFor.getBoundingClientRect();
    const displayFromRight = this.props.isRtl;
    const style = {
      top: `${bounds.top + Math.floor(bounds.height / 2)}px`
    };

    if (displayFromRight) {
      style.left = `${bounds.right}px`;
    } else {
      style.right = `${document.body.offsetWidth - bounds.left}px`;
    }

    ReactDOM.render((
      <div style={style} className="tooltip-container">
        <div className="tooltip-content">
          { this.props.children }
        </div>
      </div>
    ), this.container);

    return null;
  }

  componentWillUnmount() {
    document.body.removeChild(this.container);
    ReactDOM.unmountComponentAtNode(this.container);
  }

  container = null;

  render = () => null;
}

Tooltip.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.object,
    PropTypes.element
  ]),
  tooltipFor: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.object,
    PropTypes.element
  ]),
  isRtl: PropTypes.bool
};
